type Cache = {
  [propsName: string]: any
}

export let cache: Cache = {}

interface MemoryStore {
  removeItem: (key: string) => void
  setItem: (key: string, value: any) => void
  getItem: <T>(key: string) => T
  __memory: boolean
}

const memoryStore: MemoryStore = {
  removeItem: function(key: string) {
    delete cache[key]
  },
  setItem: function(key: string, value: any) {
    cache[key] = value
  },
  getItem: function(key: string) {
    return cache[key]
  },
  __memory: true,
}

export default memoryStore
